import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const n = ({
  title: e,
  titleId: o,
  ...c
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M887.893 763.339c-36.245 55.915-68.651 130.56-145.941 130.56-3.392 0-6.805-.213-10.219-.619-.853 0-1.707 0-2.56-.235-38.4-4.267-75.52-11.733-112-25.813-38.613-14.933-73.621-37.12-107.947-59.733-90.453-59.52-173.013-132.267-237.013-219.925-1.515-2.155-3.221-4.267-4.693-6.421-30.528-42.027-59.733-85.12-81.067-132.48-17.088-37.333-29.461-79.552-34.795-121.792-.213-1.301-.619-2.581-.619-3.861-.213-.427-.213-.853-.213-1.28-.427-5.099-1.088-10.24-1.28-15.147-.213-.853-.213-1.707-.213-2.56 0-37.973 18.56-71.467 47.147-91.733l12.139-8.085c.448 0 .64-.235.875-.427l72.107-46.741c23.659-15.147 55.253-7.253 68.693 17.28l83.819 150.827c11.328 20.48 6.421 46.08-11.712 61.013l-39.467 32.427c-19.413 15.787-23.68 43.947-9.6 64.64 24.96 37.12 50.56 74.453 82.56 106.261 31.765 31.552 68.885 57.152 105.813 82.112 20.693 14.08 48.853 9.813 64.619-9.6l32.448-39.467c14.933-18.112 40.512-23.232 61.013-11.712l150.805 83.819c24.555 13.44 32.448 45.035 17.301 68.693z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = i(n);
export {
  m as default
};
